var module = angular.module('octopusApp.management', []);

module.config(function($stateProvider) {
    $stateProvider.state("app.console", {
        url: '/manage/console',
        templateUrl: 'areas/management/views/console.html',
        controller: 'ScriptConsoleController',
        controllerAs: 'vm',
        layout: {
            title: 'Script Console',
            tab: 'tasks'
        }
    });
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/management/management_module.js
// module id = 6874433273334997
// module chunks = 1